import React from "react";
import { useSelector } from "react-redux";

import HomeUniRecruit from "../admin/uniRecruit/homePage";
import OpenJobPage from "../user/Unirecruit/openjob";

const UniRecruit = () => {
  const { result: userProfile } = useSelector((state) => state.userProfile);
  return (
    <>
      {userProfile ? (
        userProfile.roles.includes("ROLE_ADMIN") ? (
          <HomeUniRecruit />
        ) : (
          <OpenJobPage />
        )
      ) : null}
    </>
  );
};

export default UniRecruit;
